import { getApiUrl } from '@api/helpers';

export const ROUTES = {
  attachments: {
    attachment: (attachmentId: string) =>
      `${getApiUrl()}/attachments/${attachmentId}`,
  },
  images: {
    image: (imageId: string) => `${getApiUrl()}/images/${imageId}`,
    cover: {
      newsItem: (slug: string, refreshOnLoad: boolean = false) =>
        `${getApiUrl()}/images/news/${slug}/cover?${
          refreshOnLoad ? Date.now() : ''
        }`,
    },
    avatar: (slug: string, refreshOnLoad: boolean = false) =>
      `${getApiUrl()}/images/members/${slug}/avatar?${
        refreshOnLoad ? Date.now() : ''
      }`,
  },
  public: {
    login: '/login',
    activateAccount: '/activate',
    forgotPassword: '/forgot-password',
  },
  portal: {
    dutySchedule: {
      overview: '/duty-schedule',
    },
    events: {
      overview: '/events',
    },
    association: {
      disciplines: '/association/disciplines',
      instructions: {
        overview: '/association/instructions/',
        details: (slug: string) => `/association/instructions/${slug}`,
      },
      rulesAndRegulations: {
        overview: '/association/regulations-and-safety/',
        details: (slug: string) =>
          `/association/regulations-and-safety/${slug}`,
      },
    },
    news: {
      overview: '/news/',
      details: (slug: string) => `/news/${slug}`,
    },
    competitions: {
      overview: '/competitions/current',
      details: (slug: string) => `/competitions/current/${slug}`,
      results: {
        overview: '/competitions/results',
        details: (slug: string) => `/competitions/results/${slug}`,
      },
    },
  },
  profile: {
    notifications: '/profile/notifications',
  },
  manage: {
    news: {
      overview: '/manage/news/overview',
      create: '/manage/news/overview/new',
      edit: (id: number) => `/manage/news/overview/edit/${id}`,
      details: (id: number) => `/manage/news/overview/${id}`,
    },
    members: {
      overview: '/manage/members/overview',
      create: '/manage/members/overview/new/',
      details: (slug: string) => `/manage/members/overview/${slug}`,
      edit: (slug: string) => `/manage/members/overview/edit/${slug}`,
    },
    association: {
      about: {
        view: '/manage/association/about',
        edit: '/manage/association/about/edit',
      },
      instructions: {
        overview: '/manage/association/instructions',
        create: '/manage/association/instructions/new/',
        details: (id: number) => `/manage/association/instructions/${id}`,
        edit: (id: number) => `/manage/association/instructions/edit/${id}`,
      },
      rulesAndRegulations: {
        overview: '/manage/association/regulations-and-safety',
        create: '/manage/association/regulations-and-safety/new/',
        details: (id: number) =>
          `/manage/association/regulations-and-safety/${id}`,
        edit: (id: number) =>
          `/manage/association/regulations-and-safety/edit/${id}`,
      },
      boardMembers: '/manage/association/board-members',
      weaponGroups: '/manage/association/weapon-groups',
    },
    authorization: {
      roles: {
        overview: '/manage/roles-and-permissions/roles',
        create: '/manage/roles-and-permissions/roles/new',
        details: (id: number) => `/manage/roles-and-permissions/roles/${id}`,
        edit: (id: number) => `/manage/roles-and-permissions/roles/edit/${id}`,
        editPermissions: (roleId: number) =>
          `/manage/roles-and-permissions/roles/edit/${roleId}/permissions`,
      },
    },
    competitions: {
      overview: '/manage/competitions/overview',
      create: '/manage/competitions/overview/new',
      edit: (slug: string) => `/manage/competitions/overview/edit/${slug}`,
      details: (slug: string) => `/manage/competitions/overview/${slug}`,
      sessionDetails: (slug: string, sessionId: number) =>
        `/manage/competitions/overview/${slug}/sessions/${sessionId}`,
      submissionDetails: (slug: string, submissionId: number) =>
        `/manage/competitions/overview/${slug}?submission=${submissionId}`,
      disciplines: {
        overview: '/manage/competitions/disciplines/overview',
        create: '/manage/competitions/disciplines/overview/new',
        edit: (slug: string) =>
          `/manage/competitions/disciplines/overview/edit/${slug}`,
        details: (slug: string) =>
          `/manage/competitions/disciplines/overview/${slug}`,
      },
    },
  },
};
